import { createEffect, createEvent, createStore, forward, is, sample, attach } from 'effector';
export function debounce(_ref) {
  var {
    source,
    timeout,
    target
  } = _ref;
  if (!is.unit(source)) throw new TypeError('source must be unit from effector');
  if (is.domain(source, {
    sid: "jne2ft"
  })) throw new TypeError('source cannot be domain');
  var $timeout = toStoreNumber(timeout);
  var saveTimeoutId = createEvent({
    name: "saveTimeoutId",
    sid: "eqtrwk"
  });
  var $timeoutId = createStore(null, {
    and: {
      serialize: 'ignore'
    },
    name: "$timeoutId",
    sid: "-5hlcyp"
  }).on(saveTimeoutId, (_, id) => id);
  var saveReject = createEvent({
    name: "saveReject",
    sid: "-m6vk0"
  }); // eslint-disable-next-line @typescript-eslint/no-empty-function

  var $rejecter = createStore(null, {
    and: {
      serialize: 'ignore'
    },
    name: "$rejecter",
    sid: "tqvf32"
  }).on(saveReject, (_, rj) => rj);
  var tick = target !== null && target !== void 0 ? target : createEvent({
    name: "tick",
    sid: "-6wklwe"
  });
  var timerBaseFx = createEffect(_ref2 => {
    var {
      parameter,
      timeout,
      timeoutId,
      rejectPromise
    } = _ref2;
    if (timeoutId) clearTimeout(timeoutId);
    if (rejectPromise) rejectPromise();
    return new Promise((resolve, reject) => {
      saveReject(reject);
      saveTimeoutId(setTimeout(resolve, timeout, parameter));
    });
  }, {
    name: "timerBaseFx",
    sid: "-xd98qa"
  });
  var timerFx = attach({
    and: {
      source: {
        timeoutId: $timeoutId,
        rejectPromise: $rejecter
      },
      mapParams: (_ref3, _ref4) => {
        var {
          parameter,
          timeout
        } = _ref3;
        var {
          timeoutId,
          rejectPromise
        } = _ref4;
        return {
          parameter,
          timeout,
          timeoutId,
          rejectPromise
        };
      },
      effect: timerBaseFx
    },
    or: {
      name: "timerFx",
      sid: "-4ab544"
    }
  });
  $rejecter.reset(timerFx.done);
  $timeoutId.reset(timerFx.done);
  sample({
    and: [{
      source: $timeout,
      clock: source,
      fn: (timeout, parameter) => ({
        timeout,
        parameter
      }),
      target: timerFx
    }],
    or: {
      sid: "m29k3f"
    }
  });
  forward({
    and: {
      from: timerFx.done.map(_ref5 => {
        var {
          result
        } = _ref5;
        return result;
      }),
      to: tick
    },
    or: {
      sid: "-32ktwy"
    }
  });
  return tick;
}

function toStoreNumber(value) {
  if (is.store(value, {
    sid: "-2xmoh9"
  })) return value;

  if (typeof value === 'number') {
    if (value < 0 || !Number.isFinite(value)) throw new Error("timeout must be positive number or zero. Received: \"".concat(value, "\""));
    return createStore(value, {
      and: {
        name: '$timeout'
      },
      sid: "-757cx6"
    });
  }

  throw new TypeError("timeout parameter in interval method should be number or Store. \"".concat(typeof value, "\" was passed"));
}